<template>
  <div class="flex flex-col gap-y-[24px]">

     <CommonSettingsPart
      :value="reviewCommonSettingsData"
      :disabled="true"
      :nosologyList="nosologyList"
      :assignmentTemplateList="assignmentTemplateList"
      :fullKzsFormData="fullKzsFormData"
    />

    <div class="flex flex-col gap-y-[24px] bg-surface-primary p-[16px] rounded-[8px]">
      <div class="text-v-ui-gray-900 text-[20px] font-semibold leading-[120%]">
        Тип КЗС и алгоритм
      </div>

      <SelectAlgoPart
        :stepFormData="reviewStepFormData"
        :typeVariants="reviewTypeVariants"
        :availableAlgorithms="reviewAvailableAlgorithms"
        :isAlgoSelectorDisabled="true"
        :disabled="true"
      />
      <DynamicAlghoritmForm
        :formConfig="algorithmData?.formConfig"
        :fullKzsFormData="fullKzsFormData"
        :disabled="true"
      />
    </div>

     <AdditionalSettingsPart
      v-model="isPressureKzsModel"
      :disabled="true"
    />

     <div class="flex gap-x-[8px]">
       <VButton type="light" label="Назад" @click="prevStepHandler" size="m" />
       <VButton type="primary" label="Добавить" @click="nextStepHandler" size="m" />
     </div>
 </div>
</template>

<script>
import { VButton } from '@gostelemed.front/rt-doctis.designsystem';
import CommonSettingsPart from './FormParts/CommonSettingsPart.vue';
import AdditionalSettingsPart from './FormParts/AdditionalSettingsPart.vue';
import DynamicAlghoritmForm from './FormParts/DynamicAlghoritmForm.vue';
import SelectAlgoPart from './FormParts/SelectAlgoPart.vue';

export default {
  name: 'CreateKzsFormStep4',
  components: {
    VButton,
    CommonSettingsPart,
    AdditionalSettingsPart,
    DynamicAlghoritmForm,
    SelectAlgoPart,
  },
  props: {
    fullKzsFormData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    nosologyList: {
      type: Array,
      required: true,
    },
    assignmentTemplateList: {
      type: Array,
      required: true,
    },
    algorithmData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },

  computed: {
    isPressureKzsModel: {
      get() {
        return this.fullKzsFormData.subType === 1
          ? [{ id: 'kzs-is-pressure-kzs-mode' }]
          : [];
      }
    },
    reviewTypeVariants() {
      return [
        { id: 0, title: 'Тревожный' },
        { id: 1, title: 'Успешный' },
      ];
    },
    reviewAvailableAlgorithms() {
      if (!this.algorithmData) return [];
      return [this.algorithmData];
    },
    reviewStepFormData() {
      const selectedType = this.reviewTypeVariants.find(
        (item) => item.id === this.fullKzsFormData?.type?.id
      ) || null;

      return {
        type: selectedType,
        algorithm: this.algorithmData || null,
      };
    },
    reviewCommonSettingsData() {
      return {
        ...this.fullKzsFormData,
        nosologyId: this.normalizeSelectorValue(this.nosologyList, this.fullKzsFormData?.nosologyId),
        assignmentTemplateId: this.normalizeSelectorValue(
          this.assignmentTemplateList,
          this.fullKzsFormData?.assignmentTemplateId
        ),
      };
    },
  },

  mounted() {
    this.parseFullKzsFormData();
  },
  methods: {
    normalizeSelectorValue(list, currentValue) {
      const rawValue = (typeof currentValue === 'object' && currentValue?.id)
        ? currentValue
        : list.find((item) => item.id === currentValue);

      if (!rawValue) return null;

      return {
        ...rawValue,
        id: rawValue.id,
        title: rawValue.title || rawValue.name || '',
      };
    },
    parseFullKzsFormData() {
      if (!this.fullKzsFormData) return;
    },
    prevStepHandler() {
      this.$emit('on-prev-step');
    },
    nextStepHandler() {
      this.$emit('on-confirm-create-kzs');
    },
  },
}
</script>
